import { client } from "utils";

export const getPublishRequestStatusesRequest = () => client.get("publish-request-statuses");
